import { initDataList } from '../../../../../../core/types/coreTypes';
import { SalesRectificationsByProductReportData } from '../../../../../types/RectificationsByProductTypes';

export const initRectificationsByProductReportData: SalesRectificationsByProductReportData = {
  ...initDataList,
  minUsedInRectifications: 0,
  maxUsedInRectifications: 0,
};
